import {HealthBookingEnum} from 'presentation/constants';
import {useServicePermission} from 'presentation/hooks/useServicePermission';
import {useAccountInformation, useMediaQueries} from 'presentation/pages';
import {useOverbookingModalStore} from 'presentation/pages/private/booking/components/Overbooking/store';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {useBookingConfirmationDrawer} from 'presentation/pages/private/booking/hooks/useBookingConfirmationDrawer';
import {ServicesTypesEnum} from 'presentation/pages/private/services/types';
import {AppointmentOption} from '../../types';
import {buildAppointmentTypes} from '../../utils/buildAppointmentTypes';
import {UseAppointmentTypeSelectProps} from './types';

export function useAppointmentTypeSelect({onClose}: UseAppointmentTypeSelectProps) {
	const {isMobile} = useMediaQueries();
	const {canOpenService} = useServicePermission();
	const setOverbookingModalOpen = useOverbookingModalStore(
		state => state.setOverbookingModalOpen,
	);
	const {setSelectedServiceType, handleOpenBookingConfirmationDrawer} =
		useBookingConfirmationDrawer();

	const updateBookingDataAndNavigate = (type: AppointmentOption) => {
		switch (type?.serviceType) {
			case ServicesTypesEnum.TELEHEALTH:
				setSelectedServiceType(BookingTypeEnum.TELEHEALTH);
				break;
			case ServicesTypesEnum.EXAMS:
				setSelectedServiceType(BookingTypeEnum.EXAM);
				break;
			case ServicesTypesEnum.HEALTH:
				setSelectedServiceType(BookingTypeEnum.HEALTH);
				break;
			case ServicesTypesEnum.ODONTO:
				setSelectedServiceType(BookingTypeEnum.ODONTO);
				break;
			default:
				break;
		}

		handleOpenBookingConfirmationDrawer();
	};

	const handleSelectAppointment = (type: AppointmentOption) => {
		onClose();

		const canAccessService = canOpenService(type.serviceType);
		if (!canAccessService) return;

		if (type.route === HealthBookingEnum.HEALTH_BOOKING_FLOW) {
			setOverbookingModalOpen(true);
			return;
		}

		updateBookingDataAndNavigate(type);
	};
	const {odontoOnly, healthOnly} = useAccountInformation();

	const APPOINTMENT_TYPE = buildAppointmentTypes({
		hideTelehealth: odontoOnly,
		hideHealth: odontoOnly,
		hideOdonto: healthOnly,
		hideExam: odontoOnly,
	});

	return {
		isMobile,
		APPOINTMENT_TYPE,
		handleSelectAppointment,
	};
}
